import { connect } from 'react-redux'
import * as action from '../../state/state-responsible/action'
import * as selector from '../../state/state-responsible/selector'
import StateResponsibleConfiguration from './StateResponsibleConfiguration'


const mapStateToProps = state => {
    return {
        stateResponsibleList: selector.selectStateResponsibleList(state),
    }
}

const mapDispatchToProps = {
    findResponsibleStateList: action.findResponsibleStateList,
    changeStateResponsible: action.changeStateResponsible,
    saveStateResponsible: action.saveStateResponsible,
}


export default connect(mapStateToProps, mapDispatchToProps)(StateResponsibleConfiguration)



// WEBPACK FOOTER //
// ./src/modules/process/component/state-responsible/StateResponsibleConfigurationContainer.js